import * as React from 'react';
import { ChangeEvent, useEffect, useMemo, useState } from 'react';

import { UseState } from '../../types';

import { AdditionalAttribute, Container, Label, RadioInput, RadioAndLabelContainer, RadioCheckMark } from './radioButton.styled';
import { RadioButtonProps } from './radioButton.types';

export const RadioButton: React.FC<RadioButtonProps> = (props: RadioButtonProps): JSX.Element => {
  const { label, isActive = false, onChange, additionalAttribute, optionName, className, name }: RadioButtonProps = props;
  const [isChecked, setIsChecked]: UseState<boolean> = useState<boolean>(isActive);
  const id: string = useMemo((): string => {
    return `${label}-${Math.floor(Math.random() * 10)}`;
  }, []);

  useEffect(
    (): void => {
      setIsChecked(isActive);
    },
    [isActive]
  );

  const onChangeAction: (e: ChangeEvent<HTMLInputElement>) => void = (e: ChangeEvent<HTMLInputElement>): void => {
    if (onChange) {
      onChange(e.target.checked);
    }
    
    setIsChecked(e.target.checked);
  };

  return (
    <Container className={className}>
      <RadioAndLabelContainer>
        <RadioInput 
          type='radio'
          name={name ?? optionName}
          id={optionName ?? id}
          checked={isChecked}
          onChange={onChangeAction}
        />
        <RadioCheckMark />
        <Label htmlFor={optionName ?? id}>{label}</Label>
      </RadioAndLabelContainer>
      <AdditionalAttribute>{additionalAttribute}</AdditionalAttribute>
    </Container>
  );
};
